import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { Reward } from '../Base';
import { RepositoryElement } from '../Repository';

export interface Performances {
  [key: string]: number; // from 0 to 5
}

export interface ForgettingCurve<T = number> {
  computedAt: T;
  memoryRetentionValues: (number | null)[]; // array of length 121
  estimatedRetentionValues: (number | null)[]; // array of length 121
}
export interface LearningPeriod<T = number> {
  totalGameSetCount: number;
  completedGameSetCount: number;
  endedAt: T;
}

export interface SpaceSummaryJson<T = number> {
  classroomId: string;
  userId: string;
  createdAt: T;
  lastModifiedAt: T;
  itemCount: number;
  gameCount: number;
  slideshowCount: number;
  pathChallengeCount: number;
  superChallengeCount: number;
  multiplayerGameCount: number;
  completedItemCount: number;
  completedGameCount: number;
  completedSlideshowCount: number;
  completedPathChallengeCount: number;
  completedSuperChallengeCount: number;
  completedMultiplayerGameCount: number;
  scoreTotal: number;
  multiplayerGameScoreTotal: number;
  performances: Performances;
  totalDurationInMs: number;
  remainingReward: Reward;
  forgettingCurve: ForgettingCurve<T> | null;
  currentLearningPeriod: LearningPeriod<T> | null;
  averageGameScore: number;
}

export class SpaceSummary
  extends RepositoryElement
  implements SpaceSummaryJson<Date>
{
  readonly classroomId!: string; // identifier,
  userId!: string;
  createdAt!: Date;
  lastModifiedAt!: Date;
  itemCount!: number;
  gameCount!: number;
  slideshowCount!: number;
  pathChallengeCount!: number;
  superChallengeCount!: number;
  multiplayerGameCount!: number;
  completedItemCount!: number;
  completedGameCount!: number;
  completedSlideshowCount!: number;
  completedPathChallengeCount!: number;
  completedSuperChallengeCount!: number;
  completedMultiplayerGameCount!: number;
  scoreTotal!: number;
  multiplayerGameScoreTotal!: number;
  performances!: Performances;
  totalDurationInMs!: number;
  remainingReward!: Reward;
  forgettingCurve!: ForgettingCurve<Date> | null;
  currentLearningPeriod!: LearningPeriod<Date> | null;
  averageGameScore!: number;

  constructor(spaceSummary: SpaceSummaryJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(spaceSummary));
  }

  id(): string {
    return `${this.classroomId}`;
  }

  toJSON(): SpaceSummaryJson {
    return deepTransformDate(this) as unknown as SpaceSummaryJson;
  }
}
